module.exports = __webpack_public_path__ + "img/Profile-7.0cf28e54.png";